import React, { useState } from "react";
import Button from "../bootstrap/Button.jsx";

const FileSelector = ({ accept = "*", defaultFilename = '', onChange = () => {}, confirmationText }) => {
  const inputRef = React.useRef();
  const [filename, setFilename] = useState(defaultFilename);

  const handleChange = (e) => {
    const file = e.target.files[0];
    setFilename(file?.name);
    onChange(file);
  };

  const selectFile = () => {
    // If confirmationText is not given then there's no confirming needed for selecting the file
    if (confirmationText ? (filename && window.confirm(confirmationText) || !filename) : true){
      inputRef.current.click();
    }
  }

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        className="d-none"
        onChange={handleChange}
        accept={accept}
      />
      <Button onClick={selectFile}>{I18n.t("upload", { scope: "di" })}</Button>
      <div className="d-inline-block ml-1">
        {filename ||
          `${I18n.t("select_file", { scope: "di" })}${accept != "*" ? ` (${accept})` : ""}`}
      </div>
    </>
  );
};

export default FileSelector;
